import { __decorate, __metadata } from 'tslib';
import { BuiltinUiState } from '../../services/store/builtin-state.js';
import { StateManager } from '../../services/store/state-manager.js';
import { Service } from '../../decorators/class/service.js';

/**
 * config级别开关
 */
let UIConfigToggle = class UIConfigToggle {
    constructor(store) {
        this.store = store;
    }
    isDisabled(info) {
        var _a, _b;
        const serviceName = info.from;
        // ui service config 是否被禁用
        const uiToggleMap = this.store.getValue(BuiltinUiState.ConfigStatus);
        return ((_b = (_a = uiToggleMap === null || uiToggleMap === void 0 ? void 0 : uiToggleMap.get(serviceName)) === null || _a === void 0 ? void 0 : _a.has(info.name)) !== null && _b !== void 0 ? _b : false);
    }
};
UIConfigToggle = __decorate([
    Service(),
    __metadata("design:paramtypes", [StateManager])
], UIConfigToggle);

export { UIConfigToggle };
//# sourceMappingURL=ui-config-toggle.js.map
